import { Flex, Box, Heading, Text, Button } from '@chakra-ui/react';

const AuthLayout = ({ children }) => {
  return (
    <Flex minH="100vh">
      {/* LEFT PANEL */}
      <Flex
        w="35%"
        bg="blue.600"
        color="white"
        direction="column"
        justify="center"
        align="center"
        p={10}
        borderRightRadius="40px"
      >
        <Heading mb={4}>Welcome Back!</Heading>
        <Text textAlign="center" fontSize="sm" mb={8}>
          Enter your company details to set up your account and access all
          features in one place.
        </Text>

        <Button variant="outline" colorScheme="whiteAlpha">
          Sign in
        </Button>
      </Flex>

      {/* RIGHT PANEL */}
      <Flex w="65%" bg="gray.50" justify="center" align="center">
        <Box w="700px" bg="white" p={8} borderRadius="xl" shadow="xl">
          {children}
        </Box>
      </Flex>
    </Flex>
  );
};

export default AuthLayout;
